import { getFileExtensionFromUrl } from '@repo/studio-utils-file-extension/file-extension'
import type { AidaMediaKind, ChatMessage } from '../types'
import type { AidaConversationMedia } from './conversation-media'
import { previousApproval } from './generating-placeholder'
import { hasPromptDetails, promptDetailsFrom } from './prompt-details'

const fallbackExtension: Record<AidaMediaKind, string> = {
  image: 'png',
  video: 'mp4',
  audio: 'mp3',
}

export function mediaLightboxSelection(
  items: readonly AidaConversationMedia[],
  selectedId: string,
) {
  const playlist = items.filter(item => item.status === 'ready' && Boolean(item.url))
  const index = playlist.findIndex(item => item.id === selectedId)
  if (index >= 0) {
    return { playlist, index }
  }
  const selected = items.find(item => item.id === selectedId)
  return { playlist: selected ? [selected] : [], index: 0 }
}

export function lightboxIndexAfterStep(index: number, delta: number, length: number) {
  if (length <= 1) {
    return index
  }
  const next = index + delta
  if (next < 0) {
    return 0
  }
  if (next >= length) {
    return length - 1
  }
  return next
}

export function toAidaLightboxItem(
  item: AidaConversationMedia,
  showInChat?: (messageId: string | undefined) => void,
  context?: {
    messages: readonly ChatMessage[]
    onEditPrompt?: (draft: string) => void
  },
) {
  const extension = item.url ? getFileExtensionFromUrl(item.url) : null
  const approval =
    item.messageId && context ? previousApproval(context.messages, item.messageId) : undefined
  const details = promptDetailsFrom({
    approval,
    media: {
      model: item.model,
      ...(item.options ? { options: item.options } : {}),
      ...(item.duration ? { duration: item.duration } : {}),
      ...(item.aspectRatio ? { aspectRatio: item.aspectRatio } : {}),
    },
  })
  return {
    url: item.url ?? '',
    fileName: `aida-${item.id}.${extension || fallbackExtension[item.kind]}`,
    kind: item.kind,
    model: item.model,
    status: item.status,
    ...(item.posterUrl ? { posterUrl: item.posterUrl } : {}),
    ...(item.messageId && showInChat ? { onShowInChat: () => showInChat(item.messageId) } : {}),
    ...(hasPromptDetails(details) ? { details } : {}),
    ...(context?.onEditPrompt ? { onEditPrompt: context.onEditPrompt } : {}),
  }
}
